// 911网 首页静态展示数据 —— 全部为占位示例，不指向真实事件
export interface LiveItem {
  id: string;
  time: string;
  tag: string;
  status: string;
  statusKind: 'live' | 'check' | 'update' | 'scene';
  text: string;
}

export interface TimelineCard {
  id: string;
  seq: string;
  batch: string;
  time: string;
  tag: string;
  title: string;
  lead: string;
  size: 'feature' | 'small';
  img?: { src: string; alt: string; ratio: string };
}

export interface SceneNote {
  id: string;
  time: string;
  place: string;
  title: string;
  body: string;
  note: string;
  img: { src: string; alt: string };
}

export interface Faq {
  q: string;
  a: string;
}

export const mastheadTabs = ['新瓜时间线', '正在发生', '第一现场', '报法与FAQ'];

export const liveItems: LiveItem[] = [
  { id: 'l1', time: '刚刚', tag: '突发', status: 'LIVE 现场', statusKind: 'live', text: '911网突发通道有新碎片入场，正文已拆分给第一轮，等待跟线补证。' },
  { id: 'l2', time: '6分钟前', tag: '跟进', status: '有更新', statusKind: 'update', text: '上一则已出复核结果：原说法时间线对不上，已修正出处，见新瓜时间线。' },
  { id: 'l3', time: '19分钟前', tag: '新瓜', status: '待核实', statusKind: 'check', text: '有人把完整截图发上来了，正逐帧对像素，先挂在“待核实”位等第三位证人。' },
  { id: 'l4', time: '32分钟前', tag: '现场', status: '多视角', statusKind: 'scene', text: '第二现场视角已就位，与首发画面有 4 秒落差，正在拼时间轴。' },
];

export const timelineCards: TimelineCard[] = [
  {
    id: 't1',
    seq: '01',
    batch: '第 214 轮',
    time: '10:41',
    tag: '紧急爆料',
    title: '一页没头没尾的聊天截图，先说清是谁在说话，再决定要不要信',
    lead: '911网第一时间拿到原始图，去背景、留水印、标归属。结论先放在最前面：碎片能对得上，但证词到齐之前，定论这一栏我们空着。',
    size: 'feature',
  },
  {
    id: 't2',
    seq: '02',
    batch: '同轮并稿',
    time: '10:33',
    tag: '辟谣',
    title: '所谓“实锤视频”被扒出是三年前的旧画面',
    lead: '911网最新消息：逐帧比对了广告牌和制服季节，时间戳对不上，已标灰待删。',
    size: 'small',
  },
  {
    id: 't3',
    seq: '03',
    batch: '第 213 轮',
    time: '10:12',
    tag: '新瓜',
    title: '当事人深夜删号后，又自己发了一句话，方向有点反转',
    lead: '先看他删的是什么，再看他补的是什么——中间隔的八分钟比两句都重要。',
    size: 'small',
  },
  {
    id: 't4',
    seq: '04',
    batch: '第 212 轮',
    time: '09:47',
    tag: '碎片',
    title: '现场掉出一张带编号的便签，编号段能对上另一条旧线',
    lead: '我们不下结论，只把两条线的编号并排放好，等第三方来认领。',
    size: 'small',
  },
  {
    id: 't5',
    seq: '05',
    batch: '第 211 轮',
    time: '09:05',
    tag: '跟进',
    title: '首发那则料今天有了第二个独立信源，可信度从“待核实”升到“基本可采”',
    lead: '评级变动也写进正文了——你看到的不只是结果，还有我们改判的理由。',
    size: 'small',
  },
  {
    id: 't6',
    seq: '06',
    batch: '第 210 轮',
    time: '08:22',
    tag: '提醒',
    title: '今早那条要追更的线，正文里留了 3 个待补的口子，都标了序号',
    lead: '跟着序号走，就知道哪里还差一块拼图，不让你在二传的二手里绕圈。',
    size: 'small',
  },
  {
    id: 't7',
    seq: '07',
    batch: '第 209 轮',
    time: '07:56',
    tag: '回顾',
    title: '昨晚那条闹了一宿的，现在回头看，关键节点就三个',
    lead: '把时间轴摊平给你，前因后果一次看完，省得来回刷二传。',
    size: 'small',
  },
];

export const sceneNotes: SceneNote[] = [
  {
    id: 's1',
    time: '今天 08:05',
    place: '编辑部 · 现场工位',
    title: '第一轮的人，是把“还没想好”直接摊在桌上的那种人',
    body: '这张桌上没有“晚点再说”。911网对突发和紧急爆料的处理，是先把碎片收进来、编号、排时间轴，再决定谁先见人。我们宁可多留几个“待补”的口子，也不把没证实的说法当成已经发生的定论写给你。',
    note: '「你看到的每一轮，都是现场还在动的那一刻。」',
    img: { src: 'https://readdy.ai/api/search-image?query=editorial%20overhead%20still%20life%20of%20a%2024-hour%20breaking%20news%20wire%20desk%20covered%20with%20stacked%20newspapers%2C%20torn%20film%20strips%20and%20red%20press%20marker%20tape%2C%20warm%20tungsten%20lamp%20light%2C%20matte%20analog%20film%20grain%2C%20muted%20cream%20terracotta%20and%20charcoal%20palette%2C%20documentary%20magazine%20cover%20composition%2C%20soft%20shadows&width=1600&height=1060&seq=hero-911-cover&orientation=landscape', alt: '911网编辑部现场桌面' },
  },
  {
    id: 's2',
    time: '昨天 23:40',
    place: '窗外 · 天刚亮',
    title: '跟一条线，常常要熬到天光才把时间轴拼齐',
    body: '所谓“第一时间”，很多时候不是跑得快，而是肯在原地等一个不敢早下的结论。我们把每个时间戳都摊开，把每个人的原话都留着，等你来对着看。',
    note: '「慢一步下判断，快一步给你第一轮。」',
    img: { src: 'https://readdy.ai/api/search-image?query=first%20light%20over%20quiet%20city%20rooftops%20seen%20through%20an%20open%20window%20with%20a%20hand%20tapping%20a%20phone%2C%20morning%20haze%2C%20muted%20cream%20and%20terracotta%20warm%20tones%2C%20editorial%20documentary%2C%20analog%20film%20grain&width=1200&height=800&seq=scene-window-911&orientation=landscape', alt: '天光下的城市窗台' },
  },
];

export const faqs: Faq[] = [
  {
    q: '911网 和“汇总二传”的区别到底在哪？',
    a: '我们的编辑路径是“先收碎片、编号、排时间轴”，再把第一轮现场直接给你，不做等你绕完所有渠道才出的二次汇总。你进站就能看到正在发生的那一段，而不是已经过手的旧结论。',
  },
  {
    q: '“待核实”和“有更新”是什么意思？我该按哪个看？',
    a: '待核实＝说法进场但还没凑够独立信源，先给你看原貌；有更新＝我们补上了新证据或改了评级，正文里会写明改判理由。急着做判断就看“基本可采”，想追全程就跟着序号走。',
  },
  {
    q: '我可以把看到的料发给你们吗？爆料怎么给？',
    a: '可以。你在正文里找到标了序号的口子，把碎片、截图和能证明“谁在说话”的上下文发进来即可。我们只采纳能追溯到源头的部分，其余一律不进正文。',
  },
  {
    q: '万一 911网 先发的说法后来被推翻了怎么办？',
    a: '推翻是第一时间站的常态。每次翻案我们都会在原条目标灰或附更正，并把新旧两条时间轴并排展示，不偷偷删。信任不是“永不犯错”，而是“错了会明说、并且让每个人都能看到改判过程”。',
  },
  {
    q: '为什么有些标题故意不下结论？',
    a: '因为结论只属于证据，不属于标题。在证人到齐之前，我们把话留在“能证明的部分”，把空缺老老实实标出来。你拿到的每一轮，都是可以被复查的。',
  },
];